import { createContext, useContext } from 'react';

export const KitBuilderContext = createContext(null);

export const KitBuilderProvider = ({ value, children }) => (
  <KitBuilderContext.Provider value={value}>{children}</KitBuilderContext.Provider>
);

export const useKitBuilder = () => {
  const context = useContext(KitBuilderContext);
  if (!context) {
    throw new Error('useKitBuilder must be used within a KitBuilderProvider');
  }
  return context;
};
